module.exports = __webpack_public_path__ + "img/alumni.38f2f077.png";